import React from 'react';

const About = () => {
  return (
    <section className="py-16 md:py-24 
      bg-gray-50 dark:bg-gray-900 
      transition-colors duration-300">

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

        <p className="text-sm font-semibold uppercase tracking-widest
          text-indigo-600 dark:text-indigo-400">
          Platforma Haqqında
        </p>

        <h2 className="mt-2 text-3xl font-extrabold sm:text-4xl
          text-gray-900 dark:text-white">
          Al, Sat, Qazan və Daimi Gəlir Əldə Et
        </h2>

        <p className="mt-4 text-lg
          text-gray-600 dark:text-gray-300">
          Bu platforma hər kəs üçün açıq olan <strong>alış-veriş və qazanc sistemidir</strong>.
          İstifadəçilər öz məhsullarını sata, başqalarından ala və
          referral sistemi ilə <strong>passiv gəlir</strong> əldə edə bilərlər.
        </p>

        {/* ÜSTÜNLÜKLƏR */}
        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 text-left">

          <div className="p-5 rounded-lg shadow
            bg-white dark:bg-gray-800">
            <h3 className="font-bold mb-2
              text-indigo-600 dark:text-indigo-400">
              🛒 Alış-Veriş
            </h3>
            <p className="text-sm
              text-gray-600 dark:text-gray-300">
              İstədiyin məhsulu sat və ya başqalarından rahatlıqla al.
            </p>
          </div>

          <div className="p-5 rounded-lg shadow
            bg-white dark:bg-gray-800">
            <h3 className="font-bold mb-2
              text-indigo-600 dark:text-indigo-400">
              🔗 Referral Sistemi
            </h3>
            <p className="text-sm
              text-gray-600 dark:text-gray-300">
              Sənə verilən linklə hər yeni üzv üçün <strong>5 AZN</strong> qazan.
            </p>
          </div>

          <div className="p-5 rounded-lg shadow
            bg-white dark:bg-gray-800">
            <h3 className="font-bold mb-2
              text-indigo-600 dark:text-indigo-400">
              💰 Maaş
            </h3>
            <p className="text-sm
              text-gray-600 dark:text-gray-300">
              Aktivlik artdıqca sistem avtomatik maaş hesablayır.
            </p>
          </div>

        </div>

        {/* MAAŞ ŞƏRTLƏRİ */}
        <div className="mt-10 p-6 rounded-lg border text-left
          bg-indigo-50 dark:bg-gray-800
          border-indigo-100 dark:border-gray-700">

          <h3 className="text-lg font-bold mb-3
            text-indigo-700 dark:text-indigo-400">
            Maaş və Qazanc Şərtləri
          </h3>

          <ul className="space-y-2 text-sm
            text-gray-700 dark:text-gray-300">
            <li>→ Sistəmə qoşulmaq üçün <strong>15 AZN</strong> ödəniş edilir</li>
            <li>→ Şəxsi <strong>referal link</strong> təqdim olunur</li>
            <li>→ Hər dəvət edilən üzv üçün <strong>5 AZN</strong> bonus</li>
            <li>→ Komanda böyüdükcə <strong>daimi maaş</strong> aktivləşir</li>
          </ul>
        </div>

        {/* CTA */}
        <div className="mt-10">
          <a
            href="/register"
            className="inline-flex items-center justify-center px-6 py-3 rounded-md
            text-white bg-indigo-600 hover:bg-indigo-700
            dark:bg-indigo-500 dark:hover:bg-indigo-600
            transition"
          >
            İndi Qoşul və Qazan →
          </a>
        </div>

      </div>
    </section>
  );
};

export default About;
